import { useState, useEffect } from 'react';
import NoteList from '../notes/NoteList';

function AllNotesPage() {
    const [isLoading, setIsLoading] = useState(true);
    const [loadedNotes, setLoadedNotes] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        fetch(
            'https://react-explore-f6049-default-rtdb.firebaseio.com/notes.json'
        ).then((response) => {
            return response.json();
        }).then((data) => {
            const notes = [];

            for (const key in data) {
                const note = {
                    id: key,
                    ...data[key]
                };

                notes.push(note);
            }

            setIsLoading(false);
            setLoadedNotes(notes);
        });
    }, []);

    if (isLoading) {
        return (
            <section>
                <p>Loading...</p>
            </section>
        );
    }

    return (
        <section>
        <h1>Notes</h1>
       <NoteList notes={loadedNotes}/>   
       </section>
    );
}

export default AllNotesPage;